export default __webpack_public_path__ + "static/media/SYS-MATCHE-5078.95121516.pdf";